module.exports = __webpack_public_path__ + "static/media/GalleryImage11.386da302.jpg";